<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-tswiter">
				<rect
					id="Rectangle_15499"
					data-name="Rectangle 15499"
					width="20"
					height="20"
					transform="translate(429 663)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_44950" data-name="Mask Group 44950" transform="translate(-429 -663)" clip-path="url(#clip-path-tswiter)">
			<g id="Layer_1-2" transform="translate(429 663)">
				<circle id="Ellipse_929" data-name="Ellipse 929" cx="10" cy="10" r="10" fill="#fff" />
				<path
					id="Path_33043"
					data-name="Path 33043"
					d="M10,0A10,10,0,1,0,20,10,10.016,10.016,0,0,0,10,0Zm4.89,8.05v.31A6.849,6.849,0,0,1,4.35,14.13a5.441,5.441,0,0,0,.57.03,4.792,4.792,0,0,0,2.99-1.03,2.426,2.426,0,0,1-2.25-1.67,2.282,2.282,0,0,0,.45.04,2.588,2.588,0,0,0,.63-.08A2.4,2.4,0,0,1,4.81,9.06V9.03a2.368,2.368,0,0,0,1.09.3,2.4,2.4,0,0,1-.74-3.21,6.827,6.827,0,0,0,4.96,2.52,2.505,2.505,0,0,1-.06-.55,2.412,2.412,0,0,1,4.17-1.65,5.048,5.048,0,0,0,1.53-.58A2.416,2.416,0,0,1,14.7,7.19a4.86,4.86,0,0,0,1.38-.38,4.917,4.917,0,0,1-1.2,1.25Z"
					fill="#969bae"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'TwitterSvg',
};
</script>
